import React, { MouseEventHandler } from 'react';
import { BtnInterface } from '../../interface/btn-interface';
import { Link } from 'react-router-dom';


const PrimaryBtn: React.FC<BtnInterface> = ({ to = '', type = 'button', onClick, children, fullWidth = true, className, disabled, onlyMobile, onlyDesktop, targetBlank }) => {
    let myClass = `justify-center rounded-md btn-primary px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm`;
    if (onlyMobile) {
        myClass += ' flex md:hidden';
    }
    else if (onlyDesktop) {
        myClass += ' hidden md:flex';
    } else {
        myClass += ' flex';
    }
    if (className) {
        myClass += ` ${className}`;
    }
    if (fullWidth) {
        myClass += ' w-full';
    } else {
        myClass += ' w-fit';
    }
    if (disabled) {
        myClass += ' opacity-50 pointer-events-none cursor-not-allowed';
    }

    const handleClick: MouseEventHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) {
            event.preventDefault()
        }
        else if (onClick) {
            onClick(event);
        }
    };

    if (to) {
        return (
            <Link
                to={to}
                className={myClass}
                tabIndex={disabled ? -1 : undefined}
                aria-disabled={disabled ? 'true' : undefined}
                onClick={handleClick}
                target={targetBlank ? "_blank" : undefined}
                rel={targetBlank ? "noopener noreferrer" : undefined}
            >
                {children}
            </Link>
        );
    } else {
        return (
            <button
                type={type}
                onClick={handleClick}
                className={myClass}
                disabled={disabled}
            >
                {children}
            </button>
        )
    }
};

export default PrimaryBtn;
